module.exports = __webpack_public_path__ + "static/media/phone-512.4176636f.png";